// ============================================================
// THEME: TALLADEGA SUPERSPEEDWAY
// ------------------------------------------------------------
// Racing skin: red + caution yellow on asphalt black, satellite
// basemap, full pit-crew/refuel/checkered-flag vocabulary.
// ============================================================

const talladega = {
  id: 'talladega',
  name: 'Talladega Superspeedway',
  short: 'TALLADEGA',

  colors: {
    pink:   '#E4002B',   // RACING RED
    teal:   '#FFC600',   // CAUTION YELLOW
    yellow: '#ffffff',
    dark:   '#000000',
    panel:  '#111111',
    text:   '#ffffff',
  },

  raw: {
    accentPrimary:   '#E4002B',
    accentSecondary: '#FFC600',
    glow:            '#FFC600',
    pinGlow:         '#E4002B',
    squadPin:        '#FFC600',
    iconText:        '#E4002B',
    iconRing:        '#FFC600',
  },

  branding: {
    logo:    '/bender-racing-logo.png',
    logoAlt: 'Bender Racing',
    title:   'TALLADEGA TRACKER',
    titleAccent: 'TRACKER',
    tagline: 'Powered by Bender Extender',
    footer:  'v2.0 • Bender Racing',
  },

  labels: {
    primaryAction:   'REFUEL',
    secondaryAction: 'PIT STOP',
    endSession:      'CHECKERED FLAG',
    startSession:    'GREEN FLAG',
    squadLabel:      'PIT CREW',
    squadCountFmt:   '{n} ACTIVE',
    rankingsLabel:   'RANK',
    liveBadge:       'LIVE',
    statsHeader:     'Race Stats',
    durationLabel:   'DURATION',
    drinksLabel:     'FUEL',
    stepsLabel:      'STEPS',
  },

  map: {
    tileUrl:         'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    tileSubdomains:  '',
    tileAttribution: 'Tiles &copy; Esri',
    maxZoom:         19,
    containerBg:     '#111411',
  },

  venueTypes: {
    default:  { emoji: '🏁', bg: 'bg-zinc-800/80',    border: 'border-zinc-500' },
    drink:    { emoji: '🍺', bg: 'bg-brand-teal/50',  border: 'border-brand-teal' },
    vendor:   { emoji: '🌭', bg: 'bg-brand-pink/50',  border: 'border-brand-pink' },
    bathroom: { emoji: '🚻', bg: 'bg-blue-500/50',    border: 'border-blue-500' },
    supply:   { emoji: '💊', bg: 'bg-emerald-500/50', border: 'border-emerald-500' },
    party:    { emoji: '🎉', bg: 'bg-purple-500/50',  border: 'border-purple-500' },
    concert:  { emoji: '🎸', bg: 'bg-orange-500/50',  border: 'border-orange-500' },
  },

  themeColor: '#000000',
  font: {
    display: "'Inter', sans-serif",
    mono:    "'JetBrains Mono', monospace",
  },
};

export default talladega;
